import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { useState as h } from "react";
import { Button as c } from "../Button/index.js";
import { CircleInfoFarFAIcon as u } from "../Icons/index.js";
import { Title as T } from "../Title/index.js";
import { Link as N } from "../Link/index.js";
import { P as n } from "../../Popover-COBqkLTt.js";
import '../../assets/index10.css';const v = "Toggletip-module__dropdown___IQOiP", x = "Toggletip-module__content___L-4h4", w = "Toggletip-module__title___nWdE-", b = "Toggletip-module__text___rNKAh", C = "Toggletip-module__footer___s-bbE", k = "Toggletip-module__actions___EA0-q", A = "Toggletip-module__link___e-LX1", t = {
  dropdown: v,
  content: x,
  title: w,
  text: b,
  footer: C,
  actions: k,
  link: A
}, y = ({
  "data-plum-id": d,
  content: m,
  title: s,
  position: _ = "bottom",
  actions: i,
  link: o,
  className: p
}) => {
  const [g, a] = h(!1);
  return /* @__PURE__ */ l(
    n,
    {
      opened: g,
      onChange: a,
      position: _,
      classNames: t,
      withArrow: !0,
      offset: 8,
      children: [
        /* @__PURE__ */ e(n.Target, { children: /* @__PURE__ */ e(
          c,
          {
            variant: "tertiary",
            size: "sm",
            onClick: () => a((r) => !r),
            "data-plum-id": d,
            className: p,
            children: /* @__PURE__ */ e(u, {})
          }
        ) }),
        /* @__PURE__ */ e(n.Dropdown, { children: /* @__PURE__ */ l("div", { className: t.content, children: [
          s && /* @__PURE__ */ e(T, { order: 6, className: t.title, children: s }),
          /* @__PURE__ */ e("p", { className: t.text, children: m }),
          (i || o) && /* @__PURE__ */ l("div", { className: t.footer, children: [
            i && /* @__PURE__ */ e("div", { className: t.actions, children: i.map((r, f) => /* @__PURE__ */ e(
              c,
              {
                onClick: r.onClick,
                variant: r.variant || "primary",
                size: "sm",
                children: r.label
              },
              f
            )) }),
            o && /* @__PURE__ */ e(
              N,
              {
                href: o.href,
                target: o.target,
                className: t.link,
                variant: "standalone",
                children: o.label
              }
            )
          ] })
        ] }) })
      ]
    }
  );
};
y.displayName = "Toggletip";
export {
  y as Toggletip
};
